// src/utils/cotizacionCalculations.ts

import {
  getLineItemIvaRateFromDetails,
  splitShippingCostForTotals
} from './orderFormUtils'

/**
 * Calcula los totales de la cotización (misma lógica de envío que pedidos):
 * - Sin cliente neto: Envío = neto (sin IVA); IVA del envío va a Impuestos
 * - Con cliente neto: Envío = bruto (con IVA); no se suma IVA de envío a Impuestos
 */
export function calculateTotals(
  items: any[] = [],
  shippingValue: string = '0',
  productDetails: { [key: string]: any } = {},
  clienteNeto: boolean = false
) {
  const subtotal = items.reduce((sum, item) => {
    return sum + (parseFloat(item.price || '0') * (item.quantity || 0))
  }, 0)
  
  const discount = items.reduce((sum, item) => {
    const d = item.discount !== undefined && item.discount !== null ? parseFloat(item.discount) : 0
    return sum + (isNaN(d) ? 0 : d)
  }, 0)
  
  const lineTaxes = clienteNeto
    ? 0
    : items.reduce((sum, item) => {
        const itemSubtotal = parseFloat(item.price) * item.quantity
        const itemDiscount = item.discount !== undefined && item.discount !== null ? Number(item.discount) : 0
        const itemIva = getLineItemIvaRateFromDetails(item, productDetails)
        return sum + ((itemSubtotal - itemDiscount) * itemIva)
      }, 0)

  const { shippingNet, shippingTax } = splitShippingCostForTotals(
    shippingValue,
    clienteNeto
  )
  const taxes = lineTaxes + shippingTax
  const total = subtotal - discount + taxes + shippingNet
  
  return {
    subtotal: subtotal.toFixed(2),
    discount: discount.toFixed(2),
    taxes: taxes.toFixed(2),
    shipping: shippingNet.toFixed(2),
    total: total.toFixed(2)
  }
}
